export const budgetsTranslations = {
  ar: {
    title: 'الميزانيات',
    addNew: 'إضافة ميزانية جديدة',
    search: 'بحث...',
    name: 'اسم الميزانية',
    description: 'الوصف',
    fiscalYear: 'السنة المالية',
    periodType: 'نوع الفترة',
    periodTypeDaily: 'يومية',
    periodTypeWeekly: 'أسبوعية',
    periodTypeMonthly: 'شهرية',
    periodTypeCustom: 'مخصصة',
    scenario: 'السيناريو',
    scenarioBase: 'أساسية',
    scenarioOptimistic: 'تفاؤلية',
    scenarioPessimistic: 'تشاؤمية',
    status: 'الحالة',
    statusDraft: 'مسودة',
    statusApproved: 'معتمدة',
    statusActive: 'نشطة',
    statusClosed: 'مغلقة',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    totalAmount: 'المبلغ الإجمالي',
    actions: 'الإجراءات',
    edit: 'تعديل',
    delete: 'حذف',
    approve: 'اعتماد',
    activate: 'تفعيل',
    close: 'إغلاق',
    loading: 'جاري تحميل الميزانيات...',
    noBudgets: 'لا توجد ميزانيات',
    saveSuccess: 'تم حفظ الميزانية بنجاح',
    saveError: 'فشل حفظ الميزانية',
    deleteSuccess: 'تم حذف الميزانية بنجاح',
    deleteError: 'فشل حذف الميزانية',
    approveSuccess: 'تم اعتماد الميزانية بنجاح',
    approveError: 'فشل اعتماد الميزانية',
    activateSuccess: 'تم تفعيل الميزانية بنجاح',
    activateError: 'فشل تفعيل الميزانية',
    closeSuccess: 'تم إغلاق الميزانية بنجاح',
    closeError: 'فشل إغلاق الميزانية',
    confirmDelete: 'هل أنت متأكد من حذف الميزانية "{name}"؟',
    confirmApprove: 'هل أنت متأكد من اعتماد هذه الميزانية؟',
    confirmActivate: 'هل أنت متأكد من تفعيل هذه الميزانية؟',
    confirmClose: 'هل أنت متأكد من إغلاق هذه الميزانية؟',
    company: 'الشركة',
    branch: 'الفرع',
    type: 'النوع',
    companyRequired: 'الشركة مطلوبة',
    nameRequired: 'اسم الميزانية مطلوب',
    fiscalYearRequired: 'السنة المالية مطلوبة',
    startDateRequired: 'تاريخ البداية مطلوب',
    endDateRequired: 'تاريخ النهاية مطلوب',
    selectCompany: 'اختر الشركة',
    selectFiscalYear: 'اختر السنة المالية',
    selectBranch: 'اختر الفرع',
    namePlaceholder: 'أدخل اسم الميزانية',
    descriptionPlaceholder: 'أدخل وصف للميزانية',
    enforceBudgetLimits: 'فرض حدود الميزانية',
    requireApprovalForOverBudget: 'يتطلب موافقة لتجاوز الميزانية',
    warningThreshold: 'عتبة التحذير (%)',
    notes: 'ملاحظات',
    notesPlaceholder: 'أدخل أي ملاحظات إضافية',
  },
  en: {
    title: 'Budgets',
    addNew: 'Add New Budget',
    search: 'Search...',
    name: 'Budget Name',
    description: 'Description',
    fiscalYear: 'Fiscal Year',
    periodType: 'Period Type',
    periodTypeDaily: 'Daily',
    periodTypeWeekly: 'Weekly',
    periodTypeMonthly: 'Monthly',
    periodTypeCustom: 'Custom',
    scenario: 'Scenario',
    scenarioBase: 'Base',
    scenarioOptimistic: 'Optimistic',
    scenarioPessimistic: 'Pessimistic',
    status: 'Status',
    statusDraft: 'Draft',
    statusApproved: 'Approved',
    statusActive: 'Active',
    statusClosed: 'Closed',
    startDate: 'Start Date',
    endDate: 'End Date',
    totalAmount: 'Total Amount',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    approve: 'Approve',
    activate: 'Activate',
    close: 'Close',
    loading: 'Loading budgets...',
    noBudgets: 'No budgets',
    saveSuccess: 'Budget saved successfully',
    saveError: 'Failed to save budget',
    deleteSuccess: 'Budget deleted successfully',
    deleteError: 'Failed to delete budget',
    approveSuccess: 'Budget approved successfully',
    approveError: 'Failed to approve budget',
    activateSuccess: 'Budget activated successfully',
    activateError: 'Failed to activate budget',
    closeSuccess: 'Budget closed successfully',
    closeError: 'Failed to close budget',
    confirmDelete: 'Are you sure you want to delete budget "{name}"?',
    confirmApprove: 'Are you sure you want to approve this budget?',
    confirmActivate: 'Are you sure you want to activate this budget?',
    confirmClose: 'Are you sure you want to close this budget?',
    company: 'Company',
    branch: 'Branch',
    type: 'Type',
    companyRequired: 'Company is required',
    nameRequired: 'Budget name is required',
    fiscalYearRequired: 'Fiscal year is required',
    startDateRequired: 'Start date is required',
    endDateRequired: 'End date is required',
    selectCompany: 'Select Company',
    selectFiscalYear: 'Select Fiscal Year',
    selectBranch: 'Select Branch',
    namePlaceholder: 'Enter budget name',
    descriptionPlaceholder: 'Enter budget description',
    enforceBudgetLimits: 'Enforce Budget Limits',
    requireApprovalForOverBudget: 'Require Approval for Over Budget',
    warningThreshold: 'Warning Threshold (%)',
    notes: 'Notes',
    notesPlaceholder: 'Enter any additional notes',
  },
  fr: {
    title: 'Budgets',
    addNew: 'Ajouter un nouveau budget',
    search: 'Rechercher...',
    name: 'Nom du budget',
    description: 'Description',
    fiscalYear: 'Année fiscale',
    periodType: 'Type de période',
    periodTypeDaily: 'Quotidien',
    periodTypeWeekly: 'Hebdomadaire',
    periodTypeMonthly: 'Mensuel',
    periodTypeCustom: 'Personnalisé',
    scenario: 'Scénario',
    scenarioBase: 'Base',
    scenarioOptimistic: 'Optimiste',
    scenarioPessimistic: 'Pessimiste',
    status: 'Statut',
    statusDraft: 'Brouillon',
    statusApproved: 'Approuvé',
    statusActive: 'Actif',
    statusClosed: 'Fermé',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    totalAmount: 'Montant total',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    approve: 'Approuver',
    activate: 'Activer',
    close: 'Fermer',
    loading: 'Chargement des budgets...',
    noBudgets: 'Aucun budget',
    saveSuccess: 'Budget enregistré avec succès',
    saveError: 'Échec de l\'enregistrement du budget',
    deleteSuccess: 'Budget supprimé avec succès',
    deleteError: 'Échec de la suppression du budget',
    approveSuccess: 'Budget approuvé avec succès',
    approveError: 'Échec de l\'approbation du budget',
    activateSuccess: 'Budget activé avec succès',
    activateError: 'Échec de l\'activation du budget',
    closeSuccess: 'Budget fermé avec succès',
    closeError: 'Échec de la fermeture du budget',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer le budget "{name}"?',
    confirmApprove: 'Êtes-vous sûr de vouloir approuver ce budget?',
    confirmActivate: 'Êtes-vous sûr de vouloir activer ce budget?',
    confirmClose: 'Êtes-vous sûr de vouloir fermer ce budget?',
    company: 'Entreprise',
    branch: 'Succursale',
    type: 'Type',
    companyRequired: 'L\'entreprise est requise',
    nameRequired: 'Le nom du budget est requis',
    fiscalYearRequired: 'L\'année fiscale est requise',
    startDateRequired: 'La date de début est requise',
    endDateRequired: 'La date de fin est requise',
    selectCompany: 'Sélectionner l\'entreprise',
    selectFiscalYear: 'Sélectionner l\'année fiscale',
    selectBranch: 'Sélectionner la succursale',
    namePlaceholder: 'Entrez le nom du budget',
    descriptionPlaceholder: 'Entrez la description du budget',
    enforceBudgetLimits: 'Appliquer les limites du budget',
    requireApprovalForOverBudget: 'Exiger une approbation pour dépasser le budget',
    warningThreshold: 'Seuil d\'avertissement (%)',
    notes: 'Notes',
    notesPlaceholder: 'Entrez des notes supplémentaires',
  },
}

